import { DropdownButton, MenuItem } from "react-bootstrap";
import React from "react";
import Api from "../../util/Api";
import * as actions from "../../actions";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { FETCH_COMPANY_ALL } from "../../actions/types";
import { setDefaultStorage } from '../../app.js';
import { EkoFormButton } from "../elements/EkoForm";
import EkoModal from "../elements/EkoModal";
import moment from "moment";

class CompanyMenu extends React.Component {

    state = {
        companies: [],
        selected: {},
        loading: false,
        branchList: [],
        activeBranchName: '',
        activeBranchId: null,
        changeBranchModal: false,
        role_id: null,
    };

    componentDidMount() {

        this.fetchCompanies();
        this.getCompanyUserBranchDetail();
    }

    fetchCompanies = () => {
        this.props.fetchData("/company/user-companies", FETCH_COMPANY_ALL);

        let localCompanies = sessionStorage.getItem('companies');

        if (localCompanies) {
            localCompanies = JSON.parse(localCompanies);

            this.setState({ companies: localCompanies.companies });
        } else {
            Api.get('/company/user-companies', (data, errors) => {

                if (errors === false) {
                    this.setState({
                        companies: data.companies,
                    });
                }
            });
        }


    }

    changeSelect = (id) => {
        var self = this;
        this.setState({
            loading: true
        }, () => {
            Api.post('/company/change-company', { id: id }, (data, errors) => {
                if (errors === false && data.status === "ok") {
                    localStorage.setItem('user', JSON.stringify(data.user));
                    setDefaultStorage(true);
                    setTimeout(() => {
                        if (parseInt(data.user.plan_id, 10) === 0) {
                            self.props.router.push('/subscriber');
                        } else {
                            if (self.props.path === '/subscriber') {
                                self.props.router.push('/dashboard');
                            } else {
                                window.location.reload();
                            }
                        }
                    }, 6000);
                }
            });
        })
    };


    get title() {
        if (this.props.customTitle) {
            return this.props.customTitle;
        }
        
        const user = JSON.parse(localStorage.getItem('user'));

        if (this.state.loading === true) {
            return "Değiştiriliyor...";
        }

        let selected = '';

        this.state.companies.forEach((company) => {
            if (parseInt(company.id, 10) === parseInt(user.company_id, 10)) {
                selected = company.firstname;
                if (company.lastname !== null && company.lastname !== '') {
                    selected += ' ' + company.lastname;
                }
            }
        });

        return selected === '' ? 'Şirket Seçiniz' : selected;
    }
    getCompanyUserBranchDetail = () => {
        var self = this;
        Api.get('/company/getCompanyUserBranchDetail', (data, errors) => {
            self.setState({
                activeBranchName: data.active_branch_name || 'Merkez',
                activeBranchId: data.active_branch_id || null,
                branchList: data.list || [],
                role_id: data.role_id || null,
            });
        });
    };
    openchangeBranchModal = () => {
        this.setState({ changeBranchModal: true });
    };
    ChangeBranchModalApi(branch) {
        var self = this;
        Api.post('/company/changeCompanyUserBranch', { branch_id: branch.id }, (data, errors) => {
            this.setState({
                changeBranchModal: true,
                activeBranchName: branch.name,
                activeBranchId: branch.id,
            }, () => {
                window.location.reload();
            });
        });

    };
    render() {
        const today = moment().startOf("day");
        return (
            <div style={{ "display": "contents" }}>
                {this.state.companies.length > 1 ? <div style={{ display: "inline-block" }}>
                    <DropdownButton style={{ marginTop: 10, marginRight: 10 }}
                        title={this.title} id="bg-nested-dropdown">
                        {this.state.companies.map((company) => {
                            const isExpired = company.expiry_date && moment(company.expiry_date, "DD-MM-YYYY").startOf("day").isSameOrBefore(today);
                            return (
                                <MenuItem
                                    onSelect={this.changeSelect}
                                    key={company.id}
                                    eventKey={company.id}
                                >
                                    {isExpired && (
                                        <i
                                            className="fa fa-exclamation-circle"
                                            style={{ color: "red", marginRight: 5 }}
                                            title="Süresi Bitmiş"
                                        />
                                    )}
                                    {company.alias_name !== null && company.alias_name !== '' ? company.alias_name + " - " : ""}
                                    {company.firstname}
                                    {company.lastname !== null && company.lastname !== '' ? " " + company.lastname : ""}

                                </MenuItem>
                            );
                        })}

                    </DropdownButton>

                </div> : null}
                {/* this.state.branchList.length > 0 ? <EkoFormButton
                    label={"Şube: "+this.state.activeBranchName}
                    className="btn btn-primary"
                    onClick={this.openchangeBranchModal}
                    style={{"marginTop": 10, "marginRight": 10}}
                />:"" */}
                <EkoModal
                    bsSize={"large"}
                    dialogClassName={""}
                    showModal={this.state.changeBranchModal}
                    title="Şube Değiştir"
                    onHide={() => {
                        this.setState({ changeBranchModal: false });
                    }}>
                    {this.state.branchList.length > 0 && (
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Şube Adı</th>
                                    <th>Adres</th>
                                    <th>Seç</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.branchList.map((branch, index) => (
                                    <tr key={branch.id || index}>
                                        <td>{branch.name}</td>
                                        <td>{branch.address || '-'}</td>
                                        <td>
                                            <button
                                                className="btn btn-success btn-sm"
                                                disabled={this.state.activeBranchId === branch.id}
                                                onClick={() => {
                                                    this.ChangeBranchModalApi(branch);
                                                }}
                                            >
                                                Seç
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </EkoModal>
            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        companies: state.data.companies || []
    };
}

export default withRouter(connect(mapStateToProps, actions)(CompanyMenu))